import { createMuiTheme, responsiveFontSizes } from "@material-ui/core";

import palette from "./palette";
import typography from "./typography";
import overrides from "./overrides";

// import breakpoints from "./breakpoints";
import spacing from "./spacing";

const baseTheme = createMuiTheme({
  spacing,
  palette,
  typography,
  overrides,
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
});

const theme = responsiveFontSizes(baseTheme, { factor: 1.4 });
export default theme;
